import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteOptionsService {
  readonly #routeOptions = new BehaviorSubject(new RouteOptions());

  public readonly routeOptions$: Observable<RouteOptions> = this.#routeOptions.asObservable();

  public hideHeaderAndFooter = (): void => {
    this.#routeOptions.next({
      ...this.#routeOptions,
      shouldHideHeaderAndFooter: true,
    });
  };

  public displayHeaderAndFooter = (): void => {
    this.#routeOptions.next({
      ...this.#routeOptions,
      shouldHideHeaderAndFooter: false,
    });
  };

  public toggleGradient(): void {
    const { classList } = document.body;
    const cssClass = 'gradient';
    classList.contains(cssClass) ? classList.remove(cssClass) : classList.add(cssClass);
  }
}

class RouteOptions {
  public shouldHideHeaderAndFooter = false;
}
